import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FieldLabel, TextField } from 't3-widgets'

import { VALIDATORS_CONFIG } from '../../../../../../common/constants'
import { validationChecker, getValidator } from '../../../common/operations'

import styles from '../pages.module.css'

const ConfirmField = ({ confirm, confirmCorrectness, intl, onConfirmChange, serverVerified }) => {
    const [confirmError, setConfirmErrorState] = useState(false)

    const conf = VALIDATORS_CONFIG.step2
    const checker = validationChecker(confirmCorrectness)

    const setConfirmError = () => {
        const errorSerialConfirm = new Error(intl.translate('ap_error_compare'))
        setConfirmErrorState(confirmCorrectness ? false : errorSerialConfirm)
    }

    if (serverVerified) {
        return (
            <div className={styles['input-field']}>
                <FieldLabel id="confirm-label" label={intl.translate('ap_step2_confirm_label')}>
                    <div className={styles['validated-input-container']}>
                        <div className={styles['validated-input-field']}>
                            <TextField
                                id="confirm-text-field"
                                value={confirm}
                                onBlur={() => getValidator(conf.serialNo.enabled.equality, setConfirmError(), null)}
                                onChange={onConfirmChange}
                                onFocus={() => setConfirmErrorState(false)}
                                error={confirmError}
                                placeholder={intl.translate('wf_reporting_required')}
                            />
                        </div>
                        {checker}
                    </div>
                </FieldLabel>
            </div>
        )
    }

    return <div />
}

ConfirmField.propTypes = {
    confirm: PropTypes.string,
    confirmCorrectness: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func),
    onConfirmChange: PropTypes.func,
    serverVerified: PropTypes.boolean
}

export { ConfirmField }
